import React, { PropsWithChildren } from 'react';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

import { ds } from '@/components/lib/design.system';

const section = StyleSheet.create({
    root: {
        backgroundColor: ds.colorValue.background.neutral.base,
        padding: 16,
    },
});

export const Section = ({ children, style }: PropsWithChildren<{ style?: StyleProp<ViewStyle> }>) => {
    return <View style={[section.root, style]}>{children}</View>;
};
